// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:29.656Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone'
})(this, function (m_module, Backbone) {

var M = m_module.M;

M.Model = M.Model || {};

/**
 * @class M.Model.InfoDialog
 *
 * Models a InfoDialog
 */
M.Model.InfoDialog = Backbone.Model.extend();

return {InfoDialogModel: M.Model.InfoDialog};

});
